import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BreadcrumbProvider } from '../../../breadcrumb/providers/breadcrumb-provider';
import { ConfigProvider } from "../../../config-provider.service";
import { Error401Component } from "../../components/error-401/error-401";

@Component({
  selector: 'error-401-page',
  providers: [],
  styleUrls: ['./error-401.scss'],
  standalone: true,
  imports: [
    Error401Component
  ],
  templateUrl: './error-401.html'
})
export class Error401PageComponent implements AfterViewInit {
    constructor(
        public breadcrumbProvider: BreadcrumbProvider,
        private config: ConfigProvider,
        private changeDetectorRef: ChangeDetectorRef,
        private translateService: TranslateService
    ) {
    }

    public ngAfterViewInit() {
        this.breadcrumbProvider.setDefaultCrumbs([]);
        this.changeDetectorRef.detectChanges();
    }
}
